import React, { useState } from "react";

const faqData = [
  {
    id: 1,
    question: "How quickly will my order be delivered?",
    answer:
      "Orders are processed within 24 hours and delivered across the United States. Standard delivery usually takes 2–4 business days, while express options are available for urgent requirements.",
  },
  {
    id: 2,
    question: "Are all printers and supplies original?",
    answer:
      "Yes. Every printer, ink cartridge, toner, and accessory sold by Awaneez is 100% genuine. We source directly from authorized manufacturers and distributors to ensure quality and warranty coverage.",
  },
  {
    id: 3,
    question: "What if I order the wrong printer or cartridge?",
    answer:
      "No worries. If the product is unused and in original condition, you can request a return or exchange within 7 days. Our team will also help you identify the correct model for your printer.",
  },
  {
    id: 4,
    question: "Do you help with printer setup and installation?",
    answer:
      "Absolutely. Our experts can guide you through installation, driver setup, Wi-Fi configuration, and troubleshooting. Support is available via phone, email, and chat.",
  },
  {
    id: 5,
    question: "Do you offer solutions for offices or bulk orders?",
    answer:
      "Yes. We provide special pricing for businesses, schools, and institutions. Bulk orders, recurring supply plans, and managed print solutions are available upon request.",
  },
];

const PromotionalTwo = () => {
  const [openId, setOpenId] = useState(null);
  const toggle = (id) => setOpenId(openId === id ? null : id);

  return (
    <section className="sx-faq-section">
      <div className="sx-faq-container">
        {/* HEADER */}
        <div className="sx-faq-head">
          <h2>Frequently Asked Questions</h2>
          <p>
            Clear answers to common questions about printers, supplies,
            delivery, and support so you can shop with confidence.
          </p>
        </div>

        {/* FAQ LIST */}
        <div className="sx-faq-list">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className={`sx-faq-item ${openId === faq.id ? "open" : ""}`}
              onClick={() => toggle(faq.id)}
            >
              <div className="sx-faq-question">
                <h4>{faq.question}</h4>
                <span className="sx-faq-icon">
                  {openId === faq.id ? "–" : "+"}
                </span>
              </div>

              <div className="sx-faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="sx-faq-cta">
          <a href="/contact-us">Need help choosing a printer? Talk to us →</a>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        /* ================= FAQ SECTION ================= */
        .sx-faq-section {
          padding: 90px 0;
          background: #f8fafc;
        }

        .sx-faq-container {
          max-width: 900px;
          margin: auto;
          padding: 0 20px;
        }

        /* HEADER */
        .sx-faq-head {
          text-align: center;
          margin-bottom: 60px;
        }

        .sx-faq-head h2 {
          font-size: 36px;
          font-weight: 800;
          color: #111;
          margin-bottom: 10px;
        }

        .sx-faq-head p {
          font-size: 16px;
          color: #555;
          max-width: 650px;
          margin: auto;
          line-height: 1.7;
        }

        /* FAQ ITEMS */
        .sx-faq-list {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .sx-faq-item {
          background: #ffffff;
          padding: 22px 24px;
          cursor: pointer;
          transition: box-shadow .3s ease;
          box-shadow: 0 4px 14px rgba(0,0,0,0.06);
        }

        .sx-faq-item.open {
          box-shadow: 0 10px 30px rgba(0,0,0,0.12);
        }

        .sx-faq-question {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
        }

        .sx-faq-question h4 {
          font-size: 17px;
          font-weight: 700;
          color: #111;
          margin: 0;
        }

        .sx-faq-icon {
          font-size: 26px;
          font-weight: 700;
          color: #0b5ed7;
          min-width: 24px;
          text-align: center;
        }

        /* ANSWER */
        .sx-faq-answer {
          max-height: 0;
          overflow: hidden;
          transition: max-height .35s ease;
        }

        .sx-faq-item.open .sx-faq-answer {
          max-height: 200px;
          margin-top: 14px;
        }

        .sx-faq-answer p {
          font-size: 15px;
          line-height: 1.7;
          color: #444;
          margin: 0;
        }

        /* CTA */
        .sx-faq-cta {
          text-align: center;
          margin-top: 70px;
        }

        .sx-faq-cta a {
          background: #0b5ed7;
          color: #fff;
          padding: 14px 34px;
          font-size: 15px;
          font-weight: 700;
          text-decoration: none;
          transition: background .25s ease;
        }

        .sx-faq-cta a:hover {
          background: #084bb0;
        }

        /* MOBILE */
        @media(max-width: 600px) {
          .sx-faq-head h2 {
            font-size: 28px;
          }
        }
      `}</style>
    </section>
  );
};

export default PromotionalTwo;
